export default __webpack_public_path__ + "static/tutorial-img2-612e34af7627c79dcc17b0933e483906.svg";